import { CodeContent, getBackendCodeSamples } from './codeContent';

export const workflowContents = (args: CodeContent): any => {
  const backendCodeSamples = getBackendCodeSamples(args);
  return backendCodeSamples;
};
